import React, { useState } from 'react';

import { isArray } from 'lodash';

// components
import ChartFilter from 'components/charts/chartFilter/chartFilter';
import ChartInfoButton from 'components/charts/chartInfoButton/chartInfoButton';
import ChartResetButton from 'components/charts/chartResetButton/chartResetButton';
import ChartTooltip from 'components/charts/chartTooltip/chartTooltip';
import DatasetCombo from 'components/charts/datasetCombo/datasetCombo';
import IWPSlider from 'components/charts/slider/slider';
import { ChartComboItem } from 'components/charts/chartCombo/chartCombo';
import LineChartNew from 'components/charts/lineChartNew/lineChartNew';
import ChartActionsMobile from 'components/charts/chartActionsMobile/chartActionsMobile';

//utils
import chartsUtils, { DataCode, Dataset } from 'utils/charts.utils';
import ChartLegend from 'components/charts/chartLegend/chartLegend';
import { propTypes } from 'gatsby-plugin-image/dist/src/components/gatsby-image.server';

// styles

const Chart3 = () => {
  const defaultDataCode = DataCode.umverteilung;

  const [chartRef, setChartRef] = useState<any>();
  const [dataset, setDataset] = useState<Dataset>(chartsUtils.getDatasets()[1]);
  const [dataCode, setDataCode] = useState<DataCode>(defaultDataCode);
  const [yearRange, setYearRange] = useState<Array<number>>([chartsUtils.getMinYear(dataset, dataCode), chartsUtils.getMaxYear(dataset, dataCode)]);
  const [noData, setNoData] = useState<boolean>(false);
  const [selectedLocations, setSelectedLocations] = useState<Array<string>>(['ch']);

  const getDatasetChartComboItem = () => {
    return {
      text: dataset.name,
      value: dataset.code,
    } as ChartComboItem;
  };

  const handleDatasetChange = (value: ChartComboItem) => {
    setDataset({
      code: value.value,
      name: value.text,
    });
  };

  const handleFilterClick = (dataCode: DataCode) => {
    setNoData(false);
    setDataCode(dataCode);
  };

  const handleChangeYear = (value: number | number[]) => {
    if (isArray(value)) {
      setYearRange(value);
    }
  };

  const handleReset = () => {
    setSelectedLocations(['ch']);
    setDataCode(defaultDataCode);
    setYearRange([chartsUtils.getMinYear(dataset, defaultDataCode), chartsUtils.getMaxYear(dataset, defaultDataCode)]);
  };

  const handleNoData = () => {
    setNoData(true);
    //setYear((year) => getNoDataNextYear(year));
  };

  const handleCallback = (chartRef: any) => {
    setChartRef(chartRef);
  };

  const handleExport = () => {
    if (chartRef) {
      chartRef.current.chart.exportChartLocal();
    }
  };

  const handleSelectedLocation = (name: string) => {
    setSelectedLocations((selectedLocations) => [...selectedLocations, name]);
  };
  const handleUnSelectedLocation = (name: string) => {
    setSelectedLocations((selectedLocations) => selectedLocations.filter((s) => s !== name));
  };

  return (
    <div className="chart2">
      <div className="grid-row chartfilters-wrapper">
        <div className="grid-cell xs-5 md-auto">
          <DatasetCombo onChange={handleDatasetChange} value={getDatasetChartComboItem()}></DatasetCombo>
        </div>
        <div className="grid-cell d-none d-md-block md-auto" style={{ minWidth: '173px' }}></div>
        <div className="grid-cell xs-12 md-grow chartfilters-slider-container">
          <IWPSlider
            range={true}
            min={chartsUtils.getMinYear(dataset, dataCode)}
            max={chartsUtils.getMaxYear(dataset, dataCode)}
            onChange={handleChangeYear}
            value={yearRange}
          />
          <ChartTooltip
            show={noData}
            text={`Sie haben ein Jahr ausgewählt, für das keine Daten verfügbar sind. Ihnen wird das nächsthöhere Jahr angezeigt. Bitte beachten Sie, dass vor ${yearRange[0]} die Steuergrundlage nur zweijährlich bemessen wurde und die Daten dadurch auch nur zweijährlich verfügbar sind.`}
          />
        </div>
        <div className="grid-cell md-auto chartfilters-actions">
          <div className="grid-row">
            <div className="grid-cell">
              <ChartResetButton onClick={handleReset} />
            </div>
            <div className="grid-cell">
              <ChartInfoButton text="Geben Sie rechts an, für welchen Zeitraum Sie sich interessieren. Wenn Sie die generierte Grafik herunterladen möchten, klicken Sie bitte auf das Pfeilsymbol links." />
            </div>
          </div>
        </div>
      </div>
      <div className="chart2-wrapper">
        <LineChartNew
          dataCode={dataCode}
          dataset={dataset}
          yearRange={yearRange}
          title="Top {DATASET} {FILTER} {YEAR_START} - {YEAR_END}"
          onNoData={handleNoData}
          onCallback={handleCallback}
          selectedLocations={selectedLocations}
          options={{
            tooltip: {
              headerLabel1: 'JAHR',
              headerLabel2: 'UMVERTEILUNG (in Pp)',
            },
            yAxis: {
              title: 'Umverteilung (in Prozentpunkten)',
              maximums: [
                { dataset: '20', value: 8 },
                { dataset: '10', value: 8 },
                { dataset: '5', value: 8 },
                { dataset: '1', value: 6 },
                { dataset: '0.1', value: 4 },
              ],
            },
          }}
          onSelectedLocation={handleSelectedLocation}
          onUnSelectedLocation={handleUnSelectedLocation}
        />
      </div>
      <ChartActionsMobile onExport={handleExport} onReset={handleReset}></ChartActionsMobile>
      <ChartLegend onExport={handleExport} />
    </div>
  );
};

export default Chart3;
